define.alias("shared/helpers/has-item", "calendar/helpers/has-item");